// External Libraries
import React from 'react';
// Material UI Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
// Constants
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';

const componentName = "EmployeeTimesheet";


const Header = (props) => {
    return (
        <CardSimple className="p-1">
            <div className="row row_margin_none">
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.beginDate.name}
                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                        fullWidth={true}
                    />
                </div> {/* .col START DATE */}
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.endDate.name}
                        floatingLabelText={LOOKUP.report.common.endDate.label}
                        hintText={LOOKUP.report.common.endDate.label}
                        fullWidth={true}
                    />
                </div> {/* .col END DATE */}
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />
                </div> {/* .col BRANCH */}
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <SelectInput
                        name={componentName + LOOKUP.report.common.employeeName.name}
                        fullWidth={true}
                        label={LOOKUP.report.common.employeeName.label + "*"}
                        floatingLabelText={LOOKUP.report.common.employeeName.label + "*"}
                        hintText={LOOKUP.report.common.employeeName.label + "*"}
                        defaultValue="0"
                        options={props.employeeOptions}
                    />
                </div> {/* .col EMPLOYEES */}
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                    <SelectInput
                        name={componentName + LOOKUP.report.common.status}
                        fullWidth={true}
                        label={LOOKUP.report.common.status}
                        floatingLabelText={LOOKUP.report.common.status}
                        hintText={LOOKUP.report.common.status}
                        options={LOOKUP.report.common.statusTimesheetOption}
                    />
                </div> {/* .col - STATUS */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs">
                    <Button
                        type="IconInButton"
                        className="pull-right ml-1 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.viewReport.name}
                        label={LOOKUP.report.common.viewReport.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.showBody}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={props.download}
                    />
                </div>
            </div>
        </CardSimple>
    )
}

export default Header;
